import { useState } from "react";
import { Instagram, Twitter, Facebook, Mail, Shield, Ticket } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await subscribeNewsletter(email);
      toast.success("Inscription confirmée. Merci !");
      setEmail("");
    } catch {
      toast.error("Impossible de vous inscrire pour le moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="bg-black border-t border-white/10 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="grid place-items-center w-8 h-8 bg-primary text-primary-foreground rounded-sm">
              <Ticket size={18} />
            </span>
            <span className="font-black tracking-tight text-xl">SPECTRA LIVE FRANCE</span>
          </div>
          <p className="mt-4 text-sm text-muted-foreground max-w-md leading-relaxed">
            Billetterie officielle pour les plus grands concerts à Paris.
            Vivez l'émotion live à Paris La Défense Arena et à l'Accor Arena.
          </p>

          <form onSubmit={submit} className="mt-6 flex gap-2 max-w-md">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre e-mail"
              className="flex-1 bg-card border border-white/10 rounded-sm px-4 py-3 text-sm focus:border-primary outline-none"
              data-testid="newsletter-input"
            />
            <button
              type="submit"
              disabled={busy}
              className="bg-primary text-primary-foreground px-5 py-3 rounded-sm font-bold text-sm hover:brightness-110 disabled:opacity-50"
              data-testid="newsletter-submit-btn"
            >
              {busy ? "…" : "S'inscrire"}
            </button>
          </form>
          <p className="overline mt-3">Recevez les annonces en avant-première</p>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-bold text-sm mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><a href="/" className="hover:text-foreground">Accueil</a></li>
            <li><a href="/#concerts" className="hover:text-foreground">Concerts</a></li>
            <li><a href="/#venues" className="hover:text-foreground">Salles</a></li>
            <li><a href="/#faq" className="hover:text-foreground">FAQ</a></li>
            <li><a href="/contact" className="hover:text-foreground">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-bold text-sm mb-4">Salles</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>Paris La Défense Arena</li>
            <li>Accor Arena (Bercy)</li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-bold text-sm mb-4">Garanties</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-2"><Shield size={14} className="text-primary" /> Paiement sécurisé Whop</li>
            <li className="flex items-center gap-2"><Ticket size={14} className="text-primary" /> Billets officiels e-ticket</li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-primary" /> Support 7j/7</li>
          </ul>
          <div className="flex items-center gap-4 mt-6 text-muted-foreground">
            <a href="#" aria-label="Instagram" className="hover:text-primary"><Instagram size={18} /></a>
            <a href="#" aria-label="Twitter" className="hover:text-primary"><Twitter size={18} /></a>
            <a href="#" aria-label="Facebook" className="hover:text-primary"><Facebook size={18} /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Spectra Live France — spectralivefrance.com</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-foreground">Mentions légales</a>
            <a href="#" className="hover:text-foreground">CGV</a>
            <a href="#" className="hover:text-foreground">Confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
